import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ApplicationAuditLog } from '../../../../../model/application-audit-log';

export interface ViewAppLogDialogData {
  applicationLog: ApplicationAuditLog;
  action: string;
}

@Component({
  selector: 'app-application-log',
  templateUrl: './applicationlog.component.html',
  styleUrls: ['./applicationlog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  encapsulation: ViewEncapsulation.None,
})
export class ApplicationLogComponent implements OnInit {
  applicationLog: ApplicationAuditLog;
  action: string;

  @Output() reloadApplicationLogs: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private dialogRef: MatDialogRef<ApplicationLogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ViewAppLogDialogData,
  ) {
    this.applicationLog = data.applicationLog;
    this.action = data.action;
  }

  ngOnInit(): void {
    // No additional initialization needed for dialog component - 08/06/2025 TK
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  ReloadApplicationLogs() {
    this.reloadApplicationLogs.emit(true);
    this.closeDialog();
  }
}
